import { useFormState } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import { Box, Button } from '@mui/material';
import { Step } from '../../../components/Step';
import { type IntegrationProps } from 'src/modules/Settings/Integrations/pages/Integration/hooks';
import { useLazyGetFactorialIntegrationUrlQuery } from 'src/shared/api/integrations/factorial';

type Step1Props = {
  props: IntegrationProps;
  isLoading?: boolean;
  isConnected?: boolean;
};

export const Step1 = ({ isLoading, isConnected }: Step1Props) => {
  const { t } = useTranslation('settings');
  const { values } = useFormState();
  const [triggerGetIntegrationUrl] = useLazyGetFactorialIntegrationUrlQuery();
  const isDisabled = isConnected;

  return (
    <Step
      title={`${t('integrations.step')} 1`}
      subtitle={t('integrations.log in to your factorial account')}
      Icon={VpnKeyIcon}
      isLoading={isLoading}
    >
      <Box>
        <Box>
          <Button
            variant="contained"
            onClick={() => triggerGetIntegrationUrl({ subsidiary: values.company })}
            disabled={isDisabled}
          >
            {isDisabled ? t('integrations.connected') : t('integrations.log in')}
          </Button>
        </Box>
      </Box>
    </Step>
  );
};
